import { combineReducers } from 'redux';
import select from './select';
import role from './role';

export default combineReducers({
  select, role,
});
